import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import { Link } from 'react-router-dom'
import Thumbnail from "../../lib/Thumbnail"
import * as RoleType from '../../constants/user/RoleType'
import { url_format } from '../../utils/formatter'

const DEFAULT_IMAGE = 'https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_L.png';
// t1.daumcdn.net/blogstatic/tistory/bg_daumblogimg_L_170817.png

@connect(state => ({
	blog: state.blog,
	user: state.user,
}), dispatch => ({}))
class BlogProfile extends Component {

	constructor(props, context) {
		super(props, context)

		this.state = this.makeState(props)
	}

	componentWillReceiveProps(nextProps) {
		this.setState(this.makeState(nextProps))
	}

	makeState(props) {
		const { blog, user } = props
		if (!blog || !user) {
			return {}
		}

		const { image, title, domain, customDomain } = blog
		const { role } = user

		return {
			title: title,
			image: image? image : DEFAULT_IMAGE,
			canAccess: RoleType.canAccess(RoleType.convertStringToRoleType(role), RoleType.OWNER),
			roleLabel: `이 블로그의 ${RoleType.getRoleLabel(role)}입니다.`,
			blogDomainUrl: customDomain? customDomain : domain,
      blogDomainLabel : customDomain? url_format(customDomain) : url_format(domain)
		}
	}

	@autobind
	handleImageLoadFail() {
		this.setState({
			image: DEFAULT_IMAGE
		})
    }

	render() {
		const { title, image, canAccess, roleLabel, blogDomainUrl, blogDomainLabel } = this.state

		return (
			<div className="aside_profile">
				<h3 className="screen_out">프로필</h3>
				<div className="wrap_thumb">
					<Link to="/setting/blog">
						<img src={Thumbnail.make('C428x428', image)} width="214" height="214" className="thumb_img" alt="" onError={this.handleImageLoadFail}/>
					</Link>
				</div>

				<div className="wrap_cont">
					<strong className="tit_profile">{ title }</strong>
					<a href={blogDomainUrl} target="_blank" className="link_profile">
						<span className="txt_url">
							{ canAccess && blogDomainLabel }
							{ !canAccess && roleLabel }
						</span>
						<span className="area_ico"><span className="ico_blog ico_blank"/></span>
					</a>
				</div>
			</div>
		)
	}
}

export default BlogProfile
